import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface ComingSoonBadgeProps {
  tooltipText?: string;
}

export function ComingSoonBadge({
  tooltipText = 'Enforce mode for Kirin AI Analysis detections is coming soon. Findings from Kirin AI Analysis are currently treated as Monitor only, even when the Chat Security policy is in Enforce mode.',
}: ComingSoonBadgeProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="secondary"
            className="text-[10px] leading-tight px-1.5 py-0 bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200 cursor-help"
          >
            Enforcement: Coming Soon
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p className="max-w-xs">{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
